export const DEBUG = true;

export const internalSettings = {
    'IS_INTERNAL': true,
}